var netalicoSearch = {
    options: {
        formSelector: '#search_mini_form',
        destinationSelector: '#search_autocomplete',
        autocomplete: 'off',
        minSearchLength: 2,
        responseFieldElements: 'ul li',
        selectClass: 'selected',
        template: '',
        submitBtn: 'button[type="submit"]',
        searchType: 'select[name="search-type"]'
    },
    responseList: {
        indexList: null,
        selected: null
    },
    element: null,
    KeyCodes: {
        HOME: 36,
        END: 35,
        ESCAPE: 27,
        ENTER: 13,
        DOWN: 40,
        UP: 38
    },

    init: function () {
        this.element = jQuery('#Search-In-Modal');
        this.autoComplete = jQuery(this.options.destinationSelector);
        this.searchForm = jQuery(this.options.formSelector);
        this.searchType = jQuery(this.options.searchType);
        this.submitBtn = this.searchForm.find(this.options.submitBtn)[0];
        _.bindAll(this, '_onKeyDown', '_onPropertyChange', '_onSubmit');

        this.submitBtn.disabled = true;

        this.element.attr('autocomplete', this.options.autocomplete);

        this.element.on('blur', jQuery.proxy(function () {
            setTimeout(jQuery.proxy(function () {
                this.autoComplete.hide();
                this._updateAriaHasPopup(false);
            }, this), 250);
        }, this));

        this.element.trigger('blur');

        this.element.on('keydown', this._onKeyDown);
        this.element.on('input propertychange', this._onPropertyChange);

        this.searchForm.on('submit', jQuery.proxy(function(e) {
            e.preventDefault();
            this._onSubmit();
            this._updateAriaHasPopup(false);
        }, this));
    },

    /**
     * @private
     * @return {Element} The first element in the suggestion list.
     */
    _getFirstVisibleElement: function () {
        return this.responseList.indexList ? this.responseList.indexList.first() : false;
    },

    /**
     * @private
     * @return {Element} The last element in the suggestion list.
     */
    _getLastElement: function () {
        return this.responseList.indexList ? this.responseList.indexList.last() : false;
    },

    /**
     * @private
     * @param {Boolean} show Set attribute aria-haspopup to "true/false" for element.
     */
    _updateAriaHasPopup: function(show) {
        if (show) {
            this.element.attr('aria-haspopup', 'true');
        } else {
            this.element.attr('aria-haspopup', 'false');
        }
    },

    /**
     * Clears the item selected from the suggestion list and resets the suggestion list.
     * @private
     * @param {Boolean} all - Controls whether to clear the suggestion list.
     */
    _resetResponseList: function (all) {
        this.responseList.selected = null;

        if (all === true) {
            this.responseList.indexList = null;
        }
    },

    /**
     * Executes when the search box is submitted. Sets the search input field to the
     * value of the selected item.
     * @private
     * @param {Event} e - The submit event
     */
    _onSubmit: function (e) {
        var value = this.element.val();
        //e.preventDefault();
        if (this.isEmpty(value)) {
            return false;
        }
        value = value.trim();
        if (this.responseList.selected) {
            value = this.responseList.selected.text();
            this.element.val(value);
        }

        if(window.searchRedirects && window.searchRedirects.hasOwnProperty('redirects')) {
            const found = window.searchRedirects.redirects.filter((r) => r.query.toLowerCase() === value.toLowerCase());
            if(found.length > 0) {
                const matchesType = found.find((r) => r.hasOwnProperty('redirect') && r.redirect.indexOf('/collections/' + this.searchType.val()) === 0);
                if(typeof matchesType !== "undefined") {
                    window.location.href = matchesType.redirect;
                    return false;
                }
            }
            if(found.length === 1 && found[0].hasOwnProperty('redirect') && found[0].redirect.indexOf('/collections/') === -1) {
                window.location.href = found[0].redirect;
                return false;
            }
        }

        if(this.searchType.val() === 'wallpaper') {
            // add hidden input to form
            this.searchForm.append('<input type="hidden" name="filter.p.product_type" value="ShopifyWallpaper">');
            this.searchForm.append('<input type="hidden" name="sort_by" value="relevance">');
        }

        setTimeout(() => {
            this.searchForm[0].submit();
        },250)
    },

    /**
     * Executes when keys are pressed in the search input field. Performs specific actions
     * depending on which keys are pressed.
     * @private
     * @param {Event} e - The key down event
     * @return {Boolean} Default return type for any unhandled keys
     */
    _onKeyDown: function (e) {
        var keyCode = e.keyCode || e.which;
        switch (keyCode) {
            case this.KeyCodes.HOME:
                this._getFirstVisibleElement().addClass(this.options.selectClass);
                this.responseList.selected = this._getFirstVisibleElement();
                break;
            case this.KeyCodes.END:
                this._getLastElement().addClass(this.options.selectClass);
                this.responseList.selected = this._getLastElement();
                break;
            case this.KeyCodes.ESCAPE:
                this._resetResponseList(true);
                this.autoComplete.hide();
                break;
            case this.KeyCodes.ENTER:
                //this.searchForm.trigger('submit');
                break;
            case this.KeyCodes.DOWN:
                if (this.responseList.indexList) {
                    if (!this.responseList.selected) {
                        this._getFirstVisibleElement().addClass(this.options.selectClass);
                        this.responseList.selected = this._getFirstVisibleElement();
                    }
                    else if (!this._getLastElement().hasClass(this.options.selectClass)) {
                        this.responseList.selected = this.responseList.selected.removeClass(this.options.selectClass).next().addClass(this.options.selectClass);
                    } else {
                        this.responseList.selected.removeClass(this.options.selectClass);
                        this._getFirstVisibleElement().addClass(this.options.selectClass);
                        this.responseList.selected = this._getFirstVisibleElement();
                    }
                    this.element.val(this.responseList.selected.text());
                    this.element.attr('aria-activedescendant', this.responseList.selected.attr('id'));
                }
                break;
            case this.KeyCodes.UP:
                if (this.responseList.indexList !== null) {
                    if (!this._getFirstVisibleElement().hasClass(this.options.selectClass)) {
                        this.responseList.selected = this.responseList.selected.removeClass(this.options.selectClass).prev().addClass(this.options.selectClass);

                    } else {
                        this.responseList.selected.removeClass(this.options.selectClass);
                        this._getLastElement().addClass(this.options.selectClass);
                        this.responseList.selected = this._getLastElement();
                    }
                    this.element.val(this.responseList.selected.text());
                    this.element.attr('aria-activedescendant', this.responseList.selected.attr('id'));
                }
                break;
            default:
                return true;
        }
    },

    /**
     * Executes when the value of the search input field changes. Executes a GET request
     * to populate a suggestion list based on entered text. Handles click (select), hover,
     * and mouseout events on the populated suggestion list dropdown.
     * @private
     */
    _onPropertyChange: function () {
        var searchField = this.element,
            clonePosition = {
                position: 'absolute',
                width: searchField.outerWidth()
            },
            dropdown = jQuery('<ul role="listbox"></ul>'),
            value = this.element.val();

        this.submitBtn.disabled = this.isEmpty(value);

        if (value.length >= parseInt(this.options.minSearchLength, 10)) {
            jQuery.getJSON('https://autocomplete.fotolia.com/?language_id=2&query=' + encodeURIComponent(value) + '&callback=?',jQuery.proxy(function (data) {
                if(_.has(data,'hits')) {
                    jQuery.each(data['hits'], function(index, element) {
                        element.index = index;
                        var html = '<li id="qs-option-' + index +'" role="option">' + element.term + '</li>';
                        dropdown.append(html);
                    });
                    this.responseList.indexList = this.autoComplete.html(dropdown)
                        .css(clonePosition)
                        .show()
                        .find(this.options.responseFieldElements + ':visible');

                    this._resetResponseList(false);
                    this.element.removeAttr('aria-activedescendant');

                    if (this.responseList.indexList.length) {
                        this._updateAriaHasPopup(true);
                    } else {
                        this._updateAriaHasPopup(false);
                    }

                    this.responseList.indexList
                        .on('click', function (e) {
                            this.responseList.selected = jQuery(e.target);
                            this.searchForm.trigger('submit');
                        }.bind(this))
                        .on('mouseenter mouseleave', function (e) {
                            this.responseList.indexList.removeClass(this.options.selectClass);
                            jQuery(e.target).addClass(this.options.selectClass);
                            this.responseList.selected = jQuery(e.target);
                            this.element.attr('aria-activedescendant', jQuery(e.target).attr('id'));
                        }.bind(this))
                        .on('mouseout', function (e) {
                            if (!this._getLastElement() && this._getLastElement().hasClass(this.options.selectClass)) {
                                jQuery(e.target).removeClass(this.options.selectClass);
                                this._resetResponseList(false);
                            }
                        }.bind(this));
                }
            }, this));
        } else {
            this._resetResponseList(true);
            this.autoComplete.hide();
            this._updateAriaHasPopup(false);
            this.element.removeAttr('aria-activedescendant');
        }
    },

    isEmpty: function(value) {
        return (value.length === 0) || (value == null) || /^\s+jQuery/.test(value);
    },
}
var limitlessSearch = Object.create(netalicoSearch);
jQuery(document).ready(function () {
    limitlessSearch.init();
});
